import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'brands',
            name: 'brand',
            class: 'Modules\\Brand\\Entities\\Brand',
        }
    },

    methods: {
        loadBrandableBrand(table, id) {
            return axios({
                method: 'get',
                url: route('api.brandables.brand', {
                    tableid: `${table}-${id}`
                })
            })
            .then(response => {
                if(response.data.success) {
                    return response.data.data
                }

                return Promise.reject(response.data.message)
            })
            .catch(error => Promise.reject(Object.values(error.response.data.errors)[0][0]))
        }
    }
}